import script from "./Error.vue?vue&type=script&setup=true&lang=js"
export * from "./Error.vue?vue&type=script&setup=true&lang=js"

import "./Error.vue?vue&type=style&index=0&id=408610a8&scoped=true&lang=css"

import exportComponent from "/srv/http/aical-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408610a8"]])

export default __exports__